import axios from 'axios'
    
//请求配置
axios.interceptors.request.use(config => {
    config.timeout = 10000; //请求的超时时间
    config.headers.apiSecret = '5f24833d4365384c3a1ac5f886507f2d'
    if(config.url.indexOf('login') != -1){
        return config
    }else{
        let token = localStorage.getItem("Authorization")
        config.headers['Authorization'] = token;
        
        return config;
    }
},
error => {
    return Promise.reject(error);
})


//响应配置
axios.interceptors.response.use(response => {
    // 响应成功的返回
    console.log(response)
    if(response.data.code === 401 || response.data.code === 20010){
         localStorage.removeItem('Authorization')
         location.hash = '/'
    }
        return response;
    },
    error => {
        console.log(error.response)
        return Promise.reject(error);
    })
export default axios;



// WEBPACK FOOTER //
// ./src/axios/config.js